import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import Lock from 'yoda-core-components/lib/assets/svg/Lock.svg';
import HeartLineBlack from 'yoda-core-components/lib/assets/svg/HeartLineBlack.svg';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import Button from 'yoda-core-components/lib/components/Button';

function DefaultList({ isSharedPrivate }) {
    const goToHome = () => {
        const url = '/';
        window.location.assign(url);
    };

    if (isSharedPrivate) {
        return (
            <div data-automation-id="emptyList" className={dt(['pt-6'])}>
                <div
                    className={dt(['md:mb-10', 'smOnly:mb-8', 'text-center'])}
                    data-automation-id="mainSection"
                >
                    <center>
                        <Icon
                            pathClassName={dt(['fill-black'])}
                            className={dt(['fill-black'])}
                            iconType="svg"
                            width="60px"
                            height="60px"
                            viewBox="0 0 60 60"
                        >
                            <Lock />
                        </Icon>
                    </center>
                    <h3
                        className={dt([
                            'text-3xlarge',
                            'font-open-sans-semibold',
                            'text-center',
                            'mt-2',
                        ])}
                    >
                        This list has been set to private
                    </h3>
                    <p className={dt(['text-normal', 'text-center', 'mt-2'])}>
                        Looks like this list's owner is no longer sharing with the public. Still
                        looking to buy someone a gift?
                    </p>
                    <Button
                        buttonType="Primary"
                        size="Md"
                        className={dt(['mt-6'])}
                        automationId="shopGifts"
                        onClick={goToHome}
                    >
                        Shop Gifts
                    </Button>
                </div>
            </div>
        );
    }

    return (
        <div data-automation-id="emptyList" className={dt(['pt-6'])}>
            <div className={dt(['md:mb-10', 'smOnly:mb-8'])} data-automation-id="mainSection">
                <center>
                    <Icon
                        iconType="svg"
                        className={dt(['w-spacing-15', 'h-spacing-15', 'object-contain'])}
                        width="60px"
                        height="60px"
                        viewBox="0 0 60 60"
                    >
                        <HeartLineBlack />
                    </Icon>
                </center>
                <h3
                    className={dt([
                        'text-3xlarge',
                        'font-open-sans-semibold',
                        'text-center',
                        'mt-2',
                    ])}
                >
                    Your List is Empty
                </h3>
                <p
                    className={dt([
                        'text-normal',
                        'text-center',
                        'mt-2',
                        'mx-auto',
                        'md:max-w-[352px]',
                    ])}
                >
                    Add some items and start organizing your shopping
                </p>
                <Button
                    buttonType="Secondary"
                    size="Md"
                    className={dt(['mt-6', 'mx-auto', 'smOnly:!w-full', 'md:!w-[300px]'])}
                    automationId="shopGifts"
                    onClick={goToHome}
                >
                    Start Shopping
                </Button>
            </div>
        </div>
    );
}

DefaultList.propTypes = {
    isSharedPrivate: PropTypes.bool,
};

DefaultList.defaultProps = {
    isSharedPrivate: false,
};

export default DefaultList;
